/**
 * 多标签页 store 模块
 * 功能：管理已打开 tab 列表与当前激活 tab，支持增删改激活
 */
const headerTabs = {
    state: {
        openTab: [],//所有打开的路由
        activeIndex: '/main', //激活状态
    },
    getters: {
        openTab: state => state.openTab,
        activeIndex: state => state.activeIndex
    },
    mutations: {
        // 添加tabs
        add_tabs(state, data) {
            state.openTab.push(data);
        },
        // 删除tabs
        delete_tabs(state, route) {
            let index = 0;
            for (let option of state.openTab) {
                if (option.route === route) {
                    break;
                }
                index++;
            }
            state.openTab.splice(index, 1);
        },
        // 设置当前激活的tab
        set_active_index(state, index) {
            state.activeIndex = index;
        },
        /** 写入菜单树数据（写入未声明的 state 字段，无实际意义） */
        set_menu(state, data) {
            state.setMenuTree = data;
        }
    },
    actions: {

    }
};

export default headerTabs
